"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnimateVideoComponent = void 0;
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b)
                if (Object.prototype.hasOwnProperty.call(b, p))
                    d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var createjs_1 = require("createjs");
function isUpgraded(element) {
    return "__rm_upgraded__" in element;
}
function hasOverlay(stage) {
    return stage && !!stage.domOverlay;
}
var AnimateVideoComponent = /** @class */ (function (_super) {
    __extends(AnimateVideoComponent, _super);
    function AnimateVideoComponent(mc, videoSource, bitmap) {
        var _this_1 = _super.call(this, mc.mode, mc.startPosition, mc.loop, mc.labels) || this;
        _this_1.__rm_upgraded__ = true;
        _this_1.cancelStageListener = null;
        _this_1.nominalBounds = new createjs_1.default.Rectangle(0, 0, 0, 0);
        _this_1.handleRemoved = function () {
            _this_1.updateDom();
        };
        var nominalBounds = mc.nominalBounds;
        Object.setPrototypeOf(mc, AnimateVideoComponent.prototype);
        var _this = mc;
        _this.__rm_upgraded__ = true;
        _this.mc = mc;
        _this.bitmapFrame = bitmap;
        _this.videoSrc = videoSource;
        _this.fps = createjs_1.default.Ticker.framerate;
        _this.tolerance = 1.5;
        _this.oldParentFrame = 0;
        _this.init();
        _this.nominalBounds = nominalBounds;
        return mc;
    }
    AnimateVideoComponent.upgrade = function (mc, videoSrc, bitmap) {
        if (isUpgraded(mc)) {
            return mc;
        }
        return new AnimateVideoComponent(mc, videoSrc, bitmap);
    };
    AnimateVideoComponent.prototype.init = function () {
        var _this_1 = this;
        this.addEventListener("removed", function () { return _this_1.updateDom(); });
    };
    AnimateVideoComponent.prototype.getContainer = function () {
        return hasOverlay(this.stage) ? this.stage.domOverlay : document.getElementById("dom_overlay_container");
    };
    AnimateVideoComponent.prototype.updateDom = function () {
        var _this_1 = this;
        if (this.stage) {
            var container = this.getContainer();
            if (!container) {
                throw new Error("AnimateHtmlComponent: Container wasn't found!");
            }
            this.cancelStageListener = this.stage.addEventListener("drawstart", function () {
                if (!_this_1.stage) {
                    _this_1.videoElem.pause();
                    if (_this_1.cancelStageListener)
                        _this_1.cancelStageListener();
                }
            });
        }
        else if (!this.stage) {
            this.videoElem.pause();
            if (this.cancelStageListener)
                this.cancelStageListener();
        }
    };
    AnimateVideoComponent.prototype.draw = function (ctx, ignoreCache) {
        //ensure video elem is always updated to latest active video
        this.videoElem = document.querySelector(".cp-video");
        //update video source if current video source doesn't match animate's
        if (!this.videoElem.src.includes(this.videoSrc.substring(2))) {
            console.log("setting video src");
            this.videoElem.src = this.videoSrc;
        }
        var buffer = new createjs_1.default.VideoBuffer(this.videoElem);
        this.bitmapFrame.image = buffer;
        var parent = this.parent;
        //check if animation has progressed since last frame
        //if not then animation is paused
        if (this.videoElem.readyState == 4 || this.videoElem.readyState == 3) {
            if (this.oldParentFrame == parent.currentFrame) {
                this.videoElem.pause();
            }
            else {
                this.videoElem.play();
                this.videoElem.muted = false;
            }
        }
        else {
            console.log("video not loaded");
        }
        //video elem and animate file syncing
        var parentTime = parent.currentFrame / this.fps;
        var videoTime = this.videoElem.currentTime;
        var delta = videoTime - parentTime;
        var isSynced = Math.abs(parentTime - videoTime) < this.tolerance ? true : false;
        var playbackRate = 1;
        if (!isSynced) {
            if (Math.abs(delta) >= 2) {
                this.videoElem.currentTime = parentTime;
            }
            else if (delta < 0) {
                playbackRate = Math.min(2, 1 + Math.abs(delta) / 2);
            }
            else {
                playbackRate = Math.max(0.1, 1 - Math.abs(delta) / 2);
            }
        }
        this.videoElem.playbackRate = playbackRate;
        this.oldParentFrame = parent.currentFrame;
        return _super.prototype.draw.call(this, ctx, ignoreCache); // This will draw the movieclip as normal
    };
    return AnimateVideoComponent;
}(createjs_1.default.MovieClip));
exports.AnimateVideoComponent = AnimateVideoComponent;
//# sourceMappingURL=video-component.js.map
//# sourceMappingURL=module.js.map